import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

// Shared with route loaders, which read the page without a hook.
export const readPage = (searchParams: URLSearchParams) =>
  parseInt(searchParams.get('page') ?? '1', 10) || 1;

/** The current page as the URL's ?page=, kept with the other search params on change. */
export const usePageParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = readPage(searchParams);

  const setPage = useCallback(
    (next: number) => {
      setSearchParams((previous) => {
        const params = new URLSearchParams(previous);
        params.set('page', next.toString());
        return params;
      });
    },
    [setSearchParams],
  );

  return { page, setPage };
};
